import { render, staticRenderFns } from "./InformationsForm.vue?vue&type=template&id=3943c4bf&"
import script from "./InformationsForm.vue?vue&type=script&lang=js&"
export * from "./InformationsForm.vue?vue&type=script&lang=js&"
import style0 from "./InformationsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports